// import { createApp } from "vue";
// import zhCn from "element-plus/es/locale/lang/zh-cn";
// import { ElConfigProvider } from "element-plus";
// import { setupApp } from './appConfig';

// //使用方法
// // ShowModal(HtmlDialog, {
// //   title: "详情",
// //   content: row.product_name,
// // });
// export default function ShowModal(component: any, props: any) {
//   const parent = document.body;
//   const dom = document.createElement("div");
//   let afterLeaveTimer: number | null = null;
//   const afterLeaveFlag = ref(false);
//   const visible = ref(false);
//   const RootComponent = {
//     inheritAttrs: false,
//     // setup(props: any, context: any) {
//     //   return { visible };
//     // },
//     render(proxy: any) {
//       return h(
//         ElConfigProvider,
//         {
//           locale: zhCn,
//         },
//         {
//           default: () => {
//             return h(component, {
//               ...proxy.$attrs,
//               modelValue: visible.value,
//               destroyOnClose: true,
//               onClose: (e: any) => {
//                 close();
//               },
//             });
//           },
//         }
//       );
//     }
//   };

//   const app = createApp(RootComponent, { ...props });
  
//   // 使用公共配置函数
//   setupApp(app);

//   app.onUnmount(() => {
//     console.log("app onUnmounted");
//   });
//   app.mount(dom);
//   parent.appendChild(dom);
//   nextTick(() => {
//     visible.value = true;
//   });

//   function close() {
//     afterLeaveFlag.value = true;
//     if (afterLeaveTimer) {
//       clearTimeout(afterLeaveTimer);
//     }
//     afterLeaveTimer = setTimeout(handleAfterLeave, 400);
//   }

//   function handleAfterLeave() {
//     if (!afterLeaveFlag.value) {
//       return;
//     }
//     afterLeaveFlag.value = false;
//     destroySelf();
//   }

//   function destroySelf() {
//     app.unmount();
//     parent.removeChild(dom);
//   }
//   return app;
// }

// render vnode方式

import { render, type App, type AppContext } from "vue";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import { ElConfigProvider } from "element-plus";

//使用方法
// ShowModal(HtmlDialog, {
//   title: "详情",
//   content: row.product_name,
// });
export default function ShowModal(component: any, props: any) {
  const parent = document.body;
  const dom = document.createElement("div");
  let afterLeaveTimer: number | null = null;
  const afterLeaveFlag = ref(false);
  const visible = ref(false);
  const RootComponent = {
    inheritAttrs: false,
    render(proxy: any) {
      return h(
        ElConfigProvider,
        {
          locale: zhCn,
        },
        {
          default: () => {
            return h(component, {
              ...proxy.$attrs,
              modelValue: visible.value,
              destroyOnClose: true,
              onClose: (e: any) => {
                close();
              },
            });
          },
        }
      );
    }
  };
  parent.appendChild(dom);
  const vNode = h(RootComponent, { ...props });
  vNode.appContext = _context;
  render(vNode, dom);
  nextTick(() => {
    visible.value = true;
  });

  function close() {
    afterLeaveFlag.value = true;
    if (afterLeaveTimer) {
      clearTimeout(afterLeaveTimer);
    }
    afterLeaveTimer = setTimeout(handleAfterLeave, 400);
  }

  function handleAfterLeave() {
    if (!afterLeaveFlag.value) {
      return;
    }
    afterLeaveFlag.value = false;
    destroySelf();
  }

  function destroySelf() {
    render(null, dom);
    parent.removeChild(dom);
  }
  return vNode;
}

let _context: AppContext | null = null;

ShowModal.install = (app: App) => {
  _context = app._context;
}

